import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import ErrorBoundary from "error/ErrorBoundary";
import AuthLayout from "layouts/auth/Auth.js";
import AdminLayout from "layouts/admin/Admin.js";
import MapsLayout from "layouts/maps/Maps";
import ProtectedRoute from "./ProtectedRoute";
import { useSelector } from "react-redux";

// Componentes envueltos con ErrorBoundary definidos FUERA de la funcion principal
// para evitar que React los desmonte enteramente en cada re-renderizado
const ProtectedAdmin = (props) => (
  <ErrorBoundary>
    <AdminLayout {...props} />
  </ErrorBoundary>
);

const ProtectedMaps = (props) => (
  <ErrorBoundary>
    <MapsLayout {...props} />
  </ErrorBoundary>
);

const PublicAuth = (props) => (
  <ErrorBoundary>
    <AuthLayout {...props} />
  </ErrorBoundary>
);

function RouterApp() {
  const token = useSelector((state) => state.login.token);

  return (
    <Switch>
      <ProtectedRoute path="/admin" token={token} component={ProtectedAdmin} />
      <ProtectedRoute path="/maps" token={token} component={ProtectedMaps} />
      <Route path="/auth" component={PublicAuth} />
      <Redirect from="/" to="/admin/dashboard" />
    </Switch>
  );
}

export default RouterApp;
